import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { bonuses } from '../data/bonuses';
import { bonusTotalValue, totalBonuses } from '../data/offer';
export function BonusSection() {
  return <section className="bg-ivory py-16 sm:py-20" aria-labelledby="bonus-title" data-id="element-18" data-mp="1yeb4ckorj8qr">
      <div className="mx-auto max-w-4xl px-4" data-id="element-19" data-mp="1yc73kbm5upup">
        <SectionHeading id="bonus-title" tone="onLight" data-id="element-20" data-mp="1apiglbiao778">I {totalBonuses} <span className="text-gold-dark" data-id="element-21" data-mp="15pcmzpsgsami">Bonus Esclusivi</span></SectionHeading>

        <ul className="mt-10 overflow-hidden rounded-2xl border border-gold/50 bg-white/70 shadow-lg shadow-navy/10" data-id="element-22" data-mp="15n9nmf5f9554">
          {bonuses.map((bonus, index) => {
          const Icon = bonus.icon;
          return <motion.li key={bonus.title} initial={{
            opacity: 0,
            y: 12
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.28,
            delay: index * 0.04,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex gap-4 border-b border-ivory-dark p-5 last:border-b-0 sm:p-6" data-id="element-23" data-mp="1eo7r8wby7an6" data-mpi={index}>
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-navy text-gold" data-id="element-24" data-mp="2jhcvcwn4vc0c">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-25" data-mp="2ofxuesqnfpn7" />
                </span>
                <div data-id="element-26" data-mp="1qu0ixfaoskkr">
                  <p className="text-xs font-bold uppercase tracking-[.14em] text-gold-dark" data-id="element-27" data-mp="1quimkwzoi12p">Bonus {bonus.number}</p>
                  <h3 className="mt-1 text-lg font-extrabold uppercase leading-tight text-navy" data-id="element-28" data-mp="1vsk77mcr68ga">{bonus.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-navy/75" data-id="element-29" data-mp="20tho7vm10wg7">{bonus.description}</p>
                </div>
              </motion.li>;
        })}
        </ul>

        <div className="mt-6 flex flex-col items-center justify-between gap-5 rounded-2xl border-2 border-gold bg-navy px-6 py-6 text-center shadow-lg shadow-navy/30 sm:flex-row sm:text-left" data-id="element-30" data-mp="3c5s7nbevrg7z">
          <div data-id="element-31" data-mp="1h23xvn775xdh">
            <p className="text-xs font-bold uppercase tracking-[.16em] text-ivory/80" data-id="element-32" data-mp="1h1u8o1tz7u8u">Valore di tutti i {totalBonuses} bonus</p>
            <p className="mt-1 text-3xl font-bold tracking-tight text-ivory/80 line-through decoration-gold decoration-2" data-id="element-33" data-mp="1c6op39o1qrnx">
              {bonusTotalValue}
            </p>
          </div>
          <div className="sm:text-right" data-id="element-34" data-mp="1m0ds9vl3kty1">
            <p className="text-xs font-bold uppercase tracking-[.16em] text-ivory/80" data-id="element-35" data-mp="yce0qtfyozie">Il tuo prezzo oggi</p>
            <p className="mt-1 inline-flex items-center gap-2 text-4xl font-bold tracking-tight text-gold" data-id="element-36" data-mp="tem45m4dgp7v">
              <GiftIcon className="h-7 w-7" aria-hidden="true" data-id="element-37" data-mp="17697g5wqey05" /> GRATIS
            </p>
          </div>
        </div>
      </div>
    </section>;
}